// removed by extract-text-webpack-plugin
module.exports = {"review-container":"_1JeonwlKeAJ0EgLobQ5rGN","reviewer":"_3fukzptnfhaXhpsm1e5KjJ","reviewer-pic":"_3Dso1LcvPd6-N-GstWg6SQ","review-user-name":"_1WoSPUbp0-oQwHNeHi2PYp","review-content":"HePMV2QwdAnCc7FMzSAbD","trip-link":"_3jcMF06F6BkUAtMEihkQSj","point-date":"_3OFMfTMsAVbB3srWgW9irP","btn-reply":"itBmByK3WMIp6VcbM6lQT","btn-reply-mobile":"tqoOZ18zGqF66Pe4IxEuL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/Review.scss
// module id = 251
// module chunks = 0 2 9